import React, { useContext } from "react";
import PropTypes from "prop-types";
import { LocalesContext } from "../../contexts/LocalesContext";
import { MqttContext } from "../../contexts/MqttContext";
import HeadComponent from "../../components/HeadComponent";
import CardComponent from "../../components/CardComponent";
import DiagnosticStatComponent from "../../components/DiagnosticStatComponent";
import ListItemComponent from "../../components/ListItemComponent";
import { gridSizesClassName } from "../../utils/gridSizes";
import {
  getMachineParamsValue,
  getMachineParamsComplete,
} from "../../utils/irriapp";

export default function DiagnosticScreen(props) {
  const { t } = useContext(LocalesContext);
  const { machineParams } = useContext(MqttContext);

  let manual = props.manuals.filter((m) => m.language.toUpperCase() === props.locale.toUpperCase() )[0]
  if (!manual) manual = props.manuals.filter((m) => m.language.toUpperCase() === 'EN' )[0]

  // RENDER
  /////////////////////////////////////////////////////////////////////////////////////////////

  return (
    <div className="">

      <CardComponent
        className={`${gridSizesClassName({ default: 24 })} c-card--hasnext`}
      >
        <div className="row row--ais">
          <div className="col-45">
            <DiagnosticStatComponent
            title={t("irriapp.diagnostic.title_diagnostic_stato_ingresso_digitali")}
              data={getMachineParamsValue(
                machineParams,
                "diagnostic_stato_ingresso_digitali"
              )}
            />
          </div>
          <div className="col-45">
            <DiagnosticStatComponent
              title={t("irriapp.diagnostic.title_diagnostic_stato_uscite_digitali")}
              data={getMachineParamsValue(
                machineParams,
                "diagnostic_stato_uscite_digitali"
              )}
            />
          </div>
        </div>
        <table className="c-table">
          <tbody>
            <tr>
              <td className="key">{t("irriapp.diagnostic.title_diagnostic_ingresso_analogico")}</td>
              <td className="value">{getMachineParamsComplete(machineParams, "diagnostic_ingresso_analogico")}</td>
              <td className="mobile">
                <span>
                  <p>{t("irriapp.diagnostic.title_diagnostic_ingresso_analogico")}</p>
                  <p>{getMachineParamsComplete(machineParams, "diagnostic_ingresso_analogico")}</p>
                </span>
              </td>
            </tr>
            <tr>
              <td className="key">{t("irriapp.diagnostic.title_diagnostic_flussometro_acqua")}</td>
              <td className="value">{getMachineParamsComplete(machineParams, "diagnostic_flussometro_acqua")}</td>
              <td className="mobile">
                <span>
                  <p>{t("irriapp.diagnostic.title_diagnostic_flussometro_acqua")}</p>
                  <p>{getMachineParamsComplete(machineParams, "diagnostic_flussometro_acqua")}</p>
                </span>
              </td>
            </tr>
            <tr>
              <td className="key">{t("irriapp.diagnostic.title_diagnostic_tensione_batteria")}</td>
              <td className="value">{getMachineParamsComplete(machineParams, "diagnostic_tensione_batteria")}</td>
              <td className="mobile">
                <span>
                  <p>{t("irriapp.diagnostic.title_diagnostic_tensione_batteria")}</p>
                  <p>{getMachineParamsComplete(machineParams, "diagnostic_tensione_batteria")}</p>
                </span>
              </td>
            </tr>
            {[1, 2, 3, 4].map((i) => (
              <>
                <tr key={`stato_motore_${i}`}>
                  <td className="key">{`${t("irriapp.diagnostic.title_diagnostic_stato_motore")} ${i}`}</td>
                  <td className={`value ${getMachineParamsValue(machineParams, `irriapp.diagnostic.diagnostic_stato_motore_${i}`) ? 'is-valid' : 'is-error'}`}>
                    {getMachineParamsValue(machineParams, `irriapp.diagnostic.diagnostic_stato_motore_${i}`) ? (
                      <i className="fas fa-check"></i>
                    ) : (
                      <i className="fas fa-times"></i>
                    )}
                  </td>
                  <td className="mobile">
                    <span>
                      <p>{`${t("irriapp.diagnostic.title_diagnostic_stato_motore")} ${i}`}</p>
                      <p>
                        {getMachineParamsValue(machineParams, `irriapp.diagnostic.diagnostic_stato_motore_${i}`) ? (
                          <i className="fas fa-check"></i>
                        ) : (
                          <i className="fas fa-times"></i>
                        )}
                      </p>
                    </span>
                  </td>
                </tr>
                <tr key={`adc_motore_${i}`}>
                  <td className="key">{`${t("irriapp.diagnostic.title_diagnostic_adc_motore")} ${i}`}</td>
                  <td className="value">{getMachineParamsComplete(machineParams, `diagnostic_adc_motore_${i}`)}</td>
                  <td className="mobile">
                    <span>
                      <p>{`${t("irriapp.diagnostic.title_diagnostic_adc_motore")} ${i}`}</p>
                      <p>{getMachineParamsComplete(machineParams, `diagnostic_adc_motore_${i}`)}</p>
                    </span>
                  </td>
                </tr>
              </>
            ))}
            <tr>
              <td className="key">{t("irriapp.diagnostic.title_diagnostic_totale_utilizzo")}</td>
              <td className="value">{getMachineParamsComplete(machineParams, "diagnostic_totale_utilizzo")}</td>
              <td className="mobile">
                <span>
                  <p>{t("irriapp.diagnostic.title_diagnostic_totale_utilizzo")}</p>
                  <p>{getMachineParamsComplete(machineParams, "diagnostic_totale_utilizzo")}</p>
                </span>
              </td>
            </tr>
            <tr>
              <td className="key">{t("irriapp.diagnostic.title_diagnostic_parziale_utilizzo")}</td>
              <td className="value">{getMachineParamsComplete(machineParams, "diagnostic_parziale_utilizzo")}</td>
              <td className="mobile">
                <span>
                  <p>{t("irriapp.diagnostic.title_diagnostic_parziale_utilizzo")}</p>
                  <p>{getMachineParamsComplete(machineParams, "diagnostic_parziale_utilizzo")}</p>
                </span>
              </td>
            </tr>
            <tr>
              <td className="key">{t("irriapp.diagnostic.title_diagnostic_contatore_accensioni_scheda")}</td>
              <td className="value">{getMachineParamsComplete(machineParams, "diagnostic_contatore_accensioni_scheda")}</td>
              <td className="mobile">
                <span>
                  <p>{t("irriapp.diagnostic.title_diagnostic_contatore_accensioni_scheda")}</p>
                  <p>{getMachineParamsComplete(machineParams, "diagnostic_contatore_accensioni_scheda")}</p>
                </span>
              </td>
            </tr>
            <tr>
              <td className="key">{t("irriapp.diagnostic.title_diagnostic_totale_acqua")}</td>
              <td className="value">{getMachineParamsComplete(machineParams, "diagnostic_totale_acqua")}</td>
              <td className="mobile">
                <span>
                  <p>{t("irriapp.diagnostic.title_diagnostic_totale_acqua")}</p>
                  <p>{getMachineParamsComplete(machineParams, "diagnostic_totale_acqua")}</p>
                </span>
              </td>
            </tr>
            <tr>
              <td className="key">{t("irriapp.diagnostic.title_diagnostic_parziale_acqua")}</td>
              <td className="value">{getMachineParamsComplete(machineParams, "diagnostic_parziale_acqua")}</td>
              <td className="mobile">
                <span>
                  <p>{t("irriapp.diagnostic.title_diagnostic_parziale_acqua")}</p>
                  <p>{getMachineParamsComplete(machineParams, "diagnostic_parziale_acqua")}</p>
                </span>
              </td>
            </tr>
            {machineParams?.conf_bar_trasduttore_soglia?.value > 0 && (
              <tr>
                <td className="key">{t("irriapp.diagnostic.title_diagnostic_pressione_acqua")}</td>
                <td className="value">{getMachineParamsComplete(machineParams, "diagnostic_pressione_acqua")}</td>
                <td className="mobile">
                  <span>
                    <p>{t("irriapp.diagnostic.title_diagnostic_pressione_acqua")}</p>
                    <p>{getMachineParamsComplete(machineParams, "diagnostic_pressione_acqua")}</p>
                  </span>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </CardComponent>

      {manual && (
        <>
          <HeadComponent title={t("application.titles.manuals")} />
          <CardComponent>
            <ListItemComponent
              title={t("application.titles.download_manual")}
            >
              <a href={manual.url} target="_blank" className="c-button">
                Download
              </a>
            </ListItemComponent>
          </CardComponent>
        </>
      )}
    </div>
  );
}

DiagnosticScreen.propTypes = {
  goBack: PropTypes.func,
};

DiagnosticScreen.defaultProps = {
  goBack: () => {},
};